import config from '../../../config';

const NEW_ALARM_OPTIONAL_COLUMNS = [
  { id: 'highestSeverity', title: 'Highest' },
  { id: 'latestSeverity', title: 'Latest' },
  { id: 'deviatingReferenceDesignation', title: 'Equipment' },
];

const ACKNOWLEDGED_ALARM_OPTIONAL_COLUMNS = [
  { id: 'highestSeverity', title: 'Highest' },
  { id: 'latestSeverity', title: 'Latest' },
  { id: 'acknowledgedBy', title: 'Acknowledged By' },
];

const RESOLVED_ALARM_OPTIONAL_COLUMNS = [
  { id: 'deviatingReferenceDesignation', title: 'Equipment' },
  { id: 'resolvedBy', title: 'Resolved By' },
];

// New tab columns:
// Highest
// Lastest
// Name
// Equipment
// Last Ocurrence

// Ackowledged tab columns:
// Highest
// Latest
// Name
// Ack by
// Ack at

// Resolved tab columns:
// Name
// Equipment
// Resolved by
// Resolved at

// On-prem hides ack/resolved user columns — don't offer them in the schema at all
const OPTIONAL_ACKNOWLEDGED = config.onPremise
  ? ACKNOWLEDGED_ALARM_OPTIONAL_COLUMNS.filter((col) => col.id !== 'acknowledgedBy')
  : ACKNOWLEDGED_ALARM_OPTIONAL_COLUMNS;
const OPTIONAL_RESOLVED = config.onPremise
  ? RESOLVED_ALARM_OPTIONAL_COLUMNS.filter((col) => col.id !== 'resolvedBy')
  : RESOLVED_ALARM_OPTIONAL_COLUMNS;

const buildAlarmPanelSchema = (admin = false) => {
  const alarmColumns = {
    type: 'object',
    title: 'Alarm list columns to exclude',
    properties: {
      new: {
        type: 'array',
        title: 'New tab',
        default: [],
        items: {
          type: 'string',
          anyOf: NEW_ALARM_OPTIONAL_COLUMNS.map((col) => ({ enum: [col.id], title: col.title })),
        },
        uniqueItems: true,
        isMulti: true,
      },
      acknowledged: {
        type: 'array',
        title: 'Acknowledged tab',
        default: [],
        items: {
          type: 'string',
          anyOf: OPTIONAL_ACKNOWLEDGED.map((col) => ({ enum: [col.id], title: col.title })),
        },
        uniqueItems: true,
        isMulti: true,
      },
      resolved: {
        type: 'array',
        title: 'Resolved tab',
        default: [],
        items: {
          type: 'string',
          anyOf: OPTIONAL_RESOLVED.map((col) => ({ enum: [col.id], title: col.title })),
        },
        uniqueItems: true,
        isMulti: true,
      },
    },
  };

  if (admin) {
    return {
      type: 'object',
      properties: {
        alarmColumns,
      },
    };
  }

  return {
    title: {
      type: 'string',
      default: 'Alarms',
    },
    options: {
      type: 'object',
      properties: {
        // Tabs are fixed (New, Acknowledged, Resolved) — no admin selection
        alarmColumns,
      },
    },
  };
};

const getAlarmPanelSchema = () => buildAlarmPanelSchema(false);
const getAlarmPanelAdminSchema = () => buildAlarmPanelSchema(true);

export { getAlarmPanelSchema, getAlarmPanelAdminSchema };
